import { Box, Typography } from "@mui/material";

// AC-8 system use notification (CSP wording: authorized use, monitoring, consent). Shown when the deployment sets
// REACT_APP_SYSTEM_USE_NOTICE=true (runtime via env.sh, or build-time for local dev).
// Signing in is the user's acknowledgement.
export const systemUseNoticeEnabled = () =>
  (window._env_ && window._env_.REACT_APP_SYSTEM_USE_NOTICE) === "true" ||
  process.env.REACT_APP_SYSTEM_USE_NOTICE === "true";

const SystemUseNotice = () => {
  if (!systemUseNoticeEnabled()) {
    return null;
  }
  return (
    <Box
      component="section"
      role="region"
      aria-label="System use notification"
      sx={{
        width: "100%",
        maxWidth: 500,
        mb: 3,
        p: 2,
        borderRadius: 2,
        border: "1px solid",
        borderColor: "warning.main",
        backgroundColor: "#fff8e6",
      }}
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
        System use notification
      </Typography>
      <Typography variant="body2" sx={{ fontSize: "0.8rem", lineHeight: 1.5 }}>
        This system is for authorized users only. Activity on it is monitored, recorded and audited,
        and may be disclosed to authorized officials. Unauthorized or improper use is prohibited and
        may result in disciplinary action and civil or criminal penalties. By signing in you consent
        to this monitoring and acknowledge that you have no expectation of privacy in your use of
        the system.
      </Typography>
    </Box>
  );
};

export default SystemUseNotice;
